
import { Directive, ElementRef, HostListener, OnInit, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[currencyInput]'
})
export class CurrencyInputDirective implements OnInit {
  @Input() decimals: number = 2;
  @Input() allowNegative: boolean = false;
  @Input() formatOnType: boolean = true;

  constructor(private el: ElementRef, private control: NgControl) { }

  ngOnInit() {
    this.transform(this.el.nativeElement.value);
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.nativeElement.value = this.parse(value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.transform(value);
  }

  transform(value: string) {
    if (value) {
      this.el.nativeElement.value = value;
    }
  }

  parse(value: string) {
    return value;
  }
}
